var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inline-input", on: { click: _vm.edit } }, [
    _c("img", {
      staticClass: "m-2",
      style: _vm.css,
      attrs: {
        width: "28px",
        src: _vm.getIcon(_vm.initialValue) || "/icons/assets/file.png"
      }
    }),
    _vm._v(" "),
    _c("i", { staticClass: "material-icons inline-input-icon" }, [
      _vm._v("edit")
    ]),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-740583ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740583ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/InlineGlobalModalAssetComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-740583ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/InlineGlobalModalAssetComponent.vue
// module chunks = 0